import VillaArticleSmall from './VillaArticleSmall';

export default VillaArticleSmall;
